<template>
  <modal-form-block @close="$emit('close')" position="center">
    <div class="glass-form-container d-flex flex-column">
      <!-- Titre + Navigation Segmentée -->
      <div class="p-3 px-sm-4 py-sm-3 pb-1 flex-shrink-0">
        <div
          class="glass-segmented-control p-1 d-flex"
          role="tablist"
          aria-label="Sélection du type de contenu"
        >
          <button
            v-for="section in ['depense', 'categorie', 'multiple']"
            :key="section"
            type="button"
            role="tab"
            :id="`tab-${section}`"
            :aria-selected="selectedSection === section"
            :aria-controls="`tabpanel-${section}`"
            :tabindex="selectedSection === section ? 0 : -1"
            class="segment-item flex-fill"
            :class="{ active: selectedSection === section }"
            @click="selectedSection = section"
          >
            <span class="segment-text text-capitalize">{{ section }}</span>
          </button>
        </div>
      </div>

      <!-- Contenu (Scrollable) -->
      <div
        class="glass-form-content p-3 px-sm-4 pb-sm-4 flex-grow-1"
        role="tabpanel"
        :id="`tabpanel-${selectedSection}`"
        :aria-labelledby="`tab-${selectedSection}`"
      >
        <transition name="fade" mode="out-in">
          <keep-alive>
            <component
              :is="currentComponent"
              :preselected-categorie-id="modalAddContent.preselectedCategorieId"
              @close="$emit('close')"
            />
          </keep-alive>
        </transition>
      </div>
    </div>
  </modal-form-block>
</template>

<script>
// Component
import ModalFormBlock from '@/components/Form/ModalFormBlock.vue'
import DepenseFormBlock from '@/components/Form/DepenseFormBlock.vue'
import CategorieFormBlock from '@/components/Form/CategorieFormBlock.vue'
import DepenseMultipleFormBlock from '@/components/Form/DepenseMultipleFormBlock.vue'

// Store
import modalAddContentStore from '@/stores/components/modalAddContent'

export default {
  name: 'FormAddContentBlock',

  components: {
    ModalFormBlock,
    DepenseFormBlock,
    CategorieFormBlock,
    DepenseMultipleFormBlock
  },

  emits: ['close'],

  setup() {
    const modalAddContent = modalAddContentStore()
    return { modalAddContent }
  },

  data() {
    return {
      selectedSection: 'depense'
    }
  },

  mounted() {
    // On regarde l'url pour afficher la bonne section
    const urlSection = this.$route.name
    if (urlSection === 'categories') this.selectedSection = 'categorie'
    else this.selectedSection = 'depense'
  },

  computed: {
    currentComponent() {
      if (this.selectedSection === 'categorie') return 'CategorieFormBlock'
      if (this.selectedSection === 'multiple') return 'DepenseMultipleFormBlock'
      return 'DepenseFormBlock'
    }
  }
}
</script>

<style scoped>
/* Container Principal */
.glass-form-container {
  background: rgba(30, 45, 67, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  width: 100%;
  max-width: 500px;
  overflow: hidden;
  max-height: 90vh; /* Empêche le débordement vertical */
}

/* Navigation Segmentée (Sober & Simple) */
.glass-segmented-control {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.segment-item {
  background: transparent;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  font-size: var(--font-size-sm); /* 16px */
  transition: all 0.2s ease;
  min-width: 0; /* permet au flex item de se réduire en dessous de son contenu */
  overflow: hidden;
}

.segment-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.segment-item:hover {
  color: rgba(255, 255, 255, 0.9);
}

.segment-item.active {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Zone de contenu */
.glass-form-content {
  overflow-y: auto; /* Scroll uniquement sur le contenu */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

/* Scrollbar Custom */
.glass-form-content::-webkit-scrollbar {
  width: 6px;
}
.glass-form-content::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
}

/* Transition plus douce (Fade) */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Mobile Responsiveness */
@media (max-width: 576px) {
  .glass-form-container {
    max-width: calc(100vw - 32px);
    width: 100%;
    border-radius: 24px; /* Consistent rounded corners */
    position: relative; /* Removes bottom sheet positioning */
    bottom: auto;
    left: auto;
    right: auto;
    margin: 0 auto;
    max-height: 85vh;
    max-height: 85dvh; /* évite le redimensionnement brutal quand le clavier s'ouvre */
  }

  .segment-item {
    padding: 6px 6px;
    font-size: var(--font-size-xs); /* 14px */
  }
}

/* Très petits écrans (≤ 380px) : padding réduit au minimum */
@media (max-width: 380px) {
  .segment-item {
    padding: 6px 4px;
    font-size: var(--font-size-xs); /* 14px — était 0.8rem/12.8px, sous le plancher */
  }
}
</style>
